import React from "react";
import {Tag} from "antd";
import {HealthCheckerNotificationMethod} from "../../../../../models/health-checker/health-checker";
import {useTranslate} from "../../../../../hooks/translate.hook";

interface HealthCheckerNotificationMethodTagProps {
    method: HealthCheckerNotificationMethod;
}

const methodColor: Record<HealthCheckerNotificationMethod, string> = {
    none: "default",
    telegram: "cyan",
    email: "geekblue",
};

export const HealthCheckerNotificationMethodTag: React.FC<HealthCheckerNotificationMethodTagProps> = ({method}) => {
    const t = useTranslate();

    return (
        <Tag color={methodColor[method]} className="health-center-check-groups__notification-method">
            {t(`HEALTH-CENTER.SETTINGS.CHECK-GROUPS.NOTIFICATION.${method.toUpperCase()}`, {
                defaultValue: method.charAt(0).toUpperCase() + method.slice(1),
            })}
        </Tag>
    );
};
